/**
 * @generated SignedSource<<a9c62c4bc2f36286acf066a25f132037>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type taskExecutionListCheckTaskExecutions$data = ReadonlyArray<{
  readonly checkValue: TaskSentiment | null;
  readonly id: string;
  readonly sectionId: string;
  readonly " $fragmentType": "taskExecutionListCheckTaskExecutions";
}>;
export type taskExecutionListCheckTaskExecutions$key = ReadonlyArray<{
  readonly " $data"?: taskExecutionListCheckTaskExecutions$data;
  readonly " $fragmentSpreads": FragmentRefs<"taskExecutionListCheckTaskExecutions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "taskExecutionListCheckTaskExecutions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sectionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionCheck",
  "abstractKey": null
};

(node as any).hash = "fa41391055d17e7213e46548c5cd83ac";

export default node;
